export default {
  eyebrow: 'Partnerportal',
  title: 'Fakturering',
  description: 'Din betalingsmetode til den månedlige platformfaktura og alle fakturaer med fuld specifikation.',
  toasts: {
    checkout_error: 'Betalingen kunne ikke startes — prøv igen.',
    action_error: 'Handlingen mislykkedes — prøv igen.',
    onboarding_error: 'Verificeringen kunne ikke startes — prøv igen.',
    payment_method_in_use:
      'Dine restaurantlicenser faktureres til denne betalingsmetode, så den kan ikke fjernes. Udskift den i stedet med en ny.',
  },
  payout_bank_account: {
    title: 'Bankkonto til udbetalinger',
    description:
      'Udbetalinger af indtægtsdeling modtages i {{currency}}. Stripe konverterer overførslen, når den ankommer.',
    toasts: {
      saved: 'Bankkonto gemt',
      save_failed: 'Vi kunne ikke gemme bankkontoen. Kontrollér oplysningerne.',
    },
  },
  payout_onboarding: {
    title: 'Opsæt din udbetalingskonto',
    description:
      'Din indtægtsdeling udbetales månedligt til en Stripe-udbetalingskonto. Gennemfør verificeringen én gang — udbetalinger er på hold, indtil den er gennemført.',
    missing: {
      title: 'Mangler stadig, før udbetalinger kan starte:',
      bank_account: 'Tilføj den bankkonto, som din indtægtsdeling skal udbetales til.',
      business_details: 'Udfyld dine virksomhedsoplysninger, såsom adresse, CVR-nummer eller registreringsnummer.',
      people: 'Tilføj oplysninger om din virksomheds repræsentant, ejere eller direktører.',
      documents: 'Upload de verificeringsdokumenter, som Stripe har bedt om.',
      terms: 'Accepter Stripes servicevilkår.',
      other: 'Angiv de resterende oplysninger, som Stripe har bedt om.',
    },
    start: 'Start verificering',
    continue: 'Fortsæt verificering',
    ready: 'Udbetalingskonto verificeret — din indtægtsdeling udbetales automatisk efter hver faktureringsperiode.',
  },
  payment_method: {
    title: 'Betalingsmetode',
    empty: 'Ingen betalingsmetode registreret — den månedlige faktura kan endnu ikke opkræves automatisk.',
    add: 'Tilføj betalingsmetode',
    replace: 'Udskift',
    remove: 'Fjern',
    remove_confirm: {
      title: 'Fjern denne betalingsmetode?',
      description:
        'Kortet/mandatet frakobles Stripe med det samme. Uden en betalingsmetode opkræves fakturaer — inklusive allerede udstedte — via den hostede Stripe-faktura i stedet for automatisk.',
      confirm: 'Fjern',
    },
  },
  invoices: {
    title: 'Fakturaer',
  },
};
